/**
 * [Phase 2c-B §4.12 NEW-3] Thin React context wrapper that subscribes to the
 * module-level singleton's event stream. Consumers should call useTTSPlayer()
 * to read state and trigger play/stop actions.
 */
import React, { createContext, useContext, useEffect, useState } from "react";
import ttsPlayer from "../services/ttsPlayer";

const TTSCtx = createContext(null);

export const TTSPlayerProvider = ({ children }) => {
  const [state, setState] = useState(() => ({
    playing: false,
    activityId: null,
    snippet: null,
  }));
  useEffect(() => ttsPlayer.subscribe(setState), []);
  return (
    <TTSCtx.Provider
      value={{
        state,
        play: (args) => ttsPlayer.play(args),
        stop: () => ttsPlayer.stop(),
      }}
    >
      {children}
    </TTSCtx.Provider>
  );
};

export const useTTSPlayer = () => {
  const ctx = useContext(TTSCtx);
  if (!ctx) {
    // Provider not mounted yet - return a no-op shape so consumers never crash.
    return {
      state: { playing: false, activityId: null, snippet: null },
      play: () => {},
      stop: () => {},
    };
  }
  return ctx;
};
